import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var ProblemsApi = /** @class */ (function () {
    function ProblemsApi(apollo) {
        this.apollo = apollo;
    }
    ProblemsApi.prototype.searchProblems = function (_a) {
        var _b = _a.where, where = _b === void 0 ? {} : _b, _c = _a.limit, limit = _c === void 0 ? 10 : _c, _d = _a.offset, offset = _d === void 0 ? 0 : _d, _e = _a.orderBy, orderBy = _e === void 0 ? {
            column: 'name',
            direction: 'desc'
        } : _e;
        return this.apollo.query({
            query: gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        query searchProblems($where: ProblemWhereInput, $limit: Int, $offset: Int, $orderBy: ProblemOrderByInput) {\n          problems(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {\n            items {\n              id\n              name\n            }\n          }\n        }\n      "], ["\n        query searchProblems($where: ProblemWhereInput, $limit: Int, $offset: Int, $orderBy: ProblemOrderByInput) {\n          problems(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {\n            items {\n              id\n              name\n            }\n          }\n        }\n      "]))),
            variables: {
                where: where,
                limit: limit,
                offset: offset,
                orderBy: orderBy
            }
        }).toPromise()
            .then(function (result) { return result['data']['problems']['items']; });
    };
    ProblemsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProblemsApi_Factory() { return new ProblemsApi(i0.ɵɵinject(i1.Apollo)); }, token: ProblemsApi, providedIn: "root" });
    return ProblemsApi;
}());
export { ProblemsApi };
var templateObject_1;
